module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=LY - Libya.f9405bc1.svg";